<div class="channels-page">
  <app-page-header section="Administration" pageTitle="Channels" [subtitle]="totalResults + ' channels total'"
    [actions]="headerActions" (actionClick)="onHeaderAction($event)"></app-page-header>

  <app-page-toolbar searchPlaceholder="Search by name or code..." [filters]="filters"
    [rightText]="channelRows.length + ' / ' + totalResults + ' channels'" (searchChange)="onSearchChange($event)"
    (filterChange)="onFilterChange($event)"></app-page-toolbar>

  <div class="channels-content">
    <div class="channels-content__table">
      <app-data-table [columns]="channelColumns" [rows]="channelRows" [totalResults]="totalResults"
        [currentPage]="currentPage" [itemsPerPage]="itemsPerPage" [showCheckboxes]="false" [showPagination]="true"
        [resultsLabel]="'channels'" [serverSidePagination]="true" [showSubText]="true" (pageChange)="onPageChange($event)"
        (itemsPerPageChange)="onItemsPerPageChange($event)" [avatarType]="'icon'"
        [actions]="channelActions"
        [iconUrl]="'assets/icons/channel-icon.svg'"></app-data-table>
    </div>
  </div>

  @if (modalData) {
    <app-confirm-action-modal
      [data]="modalData"
      [isOpen]="isModalOpen"
      (actionTriggered)="onModalAction($event)"
      (dismissed)="onModalDismiss()">
    </app-confirm-action-modal>
  }
</div>